import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Action Types">

/**
 * Action types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetMediasByIds = '[STORE | AUTHOR | MEDIA] Get Medias By Ids',
  GetMediasByIdsSuccess = '[STORE | AUTHOR | MEDIA] Get Medias By Ids Success',
  GetMediasUsedInSuccess = '[STORE | AUTHOR | MEDIA] Get Medias Used In Success',
  FindSuccess = '[STORE | AUTHOR | MEDIA] Find Success',
  GenerateSlidePdf = '[STORE | AUTHOR | MEDIA] Generate Slide Pdf',
  GenerateChapterPdf = '[STORE | AUTHOR | MEDIA] Generate Chapter Pdf',
  AddWatermark = '[STORE | AUTHOR | MEDIA] Add Watermark',
  /**
   * Request
   */
  GetMediasByIdsRequest = '[REQUEST | AUTHOR | MEDIA] Get Medias By Ids Request',
  GenerateSlidePdfRequest = '[REQUEST | AUTHOR | MEDIA] Generate Slide Pdf Request',
  GenerateChapterPdfRequest = '[REQUEST | AUTHOR | MEDIA] Generate Chapter Pdf Request',
  AddWatermarkRequest = '[REQUEST | AUTHOR | MEDIA] Add Watermark Request',
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Medias By Ids
 */
export class GetMediasByIds {
  public static readonly type = ActionTypes.GetMediasByIds;

  public constructor(public ids: string[],
                     public force = false) {
  }
}

/**
 * Get Medias By Ids Success
 */
export class GetMediasByIdsSuccess {
  public static readonly type = ActionTypes.GetMediasByIdsSuccess;

  public constructor(public entities: FlatModels.MediaAuthorModels.SearchResult[]) {
  }
}

/**
 * Get Media Used In Success
 */
export class GetMediasUsedInSuccess {
  public static readonly type = ActionTypes.GetMediasUsedInSuccess;

  public constructor(public entityQueryResults: FlatModels.MediaAuthorModels.MediaUsedInResult[]) {
  }
}

/**
 * Find Success
 */
export class FindSuccess {
  public static readonly type = ActionTypes.FindSuccess;
}

/**
 * Generate Slide Pdf
 */
export class GenerateSlidePdf {
  public static readonly type = ActionTypes.GenerateSlidePdf;

  public constructor(public id: string,
                     public forAuthor: boolean) {
  }
}

/**
 * Generate Chapter Pdf
 */
export class GenerateChapterPdf {
  public static readonly type = ActionTypes.GenerateChapterPdf;

  public constructor(public id: string,
                     public forceGeneration: boolean,
                     public forAuthor: boolean) {
  }
}

/**
 * Add Watermark
 */
export class AddWatermark {
  public static readonly type = ActionTypes.AddWatermark;
  
  public constructor(public media: FlatModels.MediaEntityModels.Media,
                     public position: FlatModels.MediaEntityModels.CopyrightPosition) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

/**
 * Get Medias By Ids Request
 */
export class GetMediasByIdsRequest {
  public static readonly type = ActionTypes.GetMediasByIdsRequest;

  public constructor(public ids: string[]) {
  }
}

/**
 * Generate Slide Pdf Request
 */
export class GenerateSlidePdfRequest {
  public static readonly type = ActionTypes.GenerateSlidePdfRequest;

  public constructor(public id: string,
                     public forAuthor: boolean) {
  }
}

/**
 * Generate Chapter Pdf Request
 */
export class GenerateChapterPdfRequest {
  public static readonly type = ActionTypes.GenerateChapterPdfRequest;

  public constructor(public id: string,
                     public forceGeneration: boolean,
                     public forAuthor: boolean) {
  }
}

/**
 * Add Watermark Request
 */
export class AddWatermarkRequest {
  public static readonly type = ActionTypes.AddWatermarkRequest;
  
  public constructor(public id: string,
                     public lines: string[],
                     public position: FlatModels.MediaEntityModels.CopyrightPosition,
                     public backgroundColor?: string,
                     public fontSize?: string) {
  }
}

// </editor-fold>
